import * as types from './mutation-types'

export const loadChecklists = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('checklists/tasks/'+data+'/collections', data).then((response) => {
            commit(types.ADD_CHECKLISTS, response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateChecklist = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put('checklists/' + data.id + '/update', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeChecklistStatus = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put('checklists/' + data.id + '/status', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createChecklist = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('checklists/tasks/'+data.task+'/store', data).then((response) => {
            commit(types.ADD_CHECKLIST, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const deleteChecklist = ({ commit }, id) => {

    return new Promise((resolve, reject) => {
        window.axios.delete('checklists/' + id + '/delete').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

